import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import { AuthService } from '../services/auth.service';
import { AppStateHolder } from './app-state.holder';
import { tap } from 'rxjs/operators';
import { AppService } from '../services/app.service';
import { map } from 'rxjs/operators'
import { Router } from '@angular/router';
import { SessionService } from '../services/session.service';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { AppProperty } from '../properties/app.property';
import { DebugLoggerService } from '../services/debug-logger.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  private _googleAnalyticsService = inject(GoogleAnalyticsService);
  private _authService = inject(AuthService);
  private _appStateHolder = inject(AppStateHolder);
  private _router = inject(Router);
  private _appProperty = inject(AppProperty);
  private _sessionService = inject(SessionService);
  private _debugLogger = inject(DebugLoggerService);


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cookie = this._appStateHolder.getCookie('authType');
    const authToken = this._appStateHolder.getCookie('authToken');
    const tokenIsValid = this._authService.tokenIsValid();

    if (cookie && cookie === 'b2c' && authToken && !tokenIsValid) {
      if (this._sessionService
        && this._sessionService.email
        && this._appProperty
        && !this._appProperty.impersonateIsActive)
        this._router.navigate(['login', this._sessionService.email]);
      else
        this._router.navigate(['/login']);

      return throwError(() => new HttpErrorResponse({
        status: 504,
        statusText: 'Gateway Timeout',
        error: { message: 'Token non valido' }
      }));
    }

    const startTime = Date.now();

    return next.handle(req).pipe(
      tap(
        response => {
          if (response instanceof HttpResponse) {
            const duration = Date.now() - startTime;
            const body = ['POST', 'PUT', 'PATCH'].includes(req.method) ? req.body : undefined;
            this._debugLogger.logHttp(req.method, req.urlWithParams, body, response.body, duration);
          }
        },
        error => {
          const duration = Date.now() - startTime;
          this._debugLogger.logHttpError(req.method, req.urlWithParams, error, duration);
        }
      ),
    );
  }
}
